<template>
  <div class="w-full pt-8 grid grid-cols-2">

    <!-- server info -->
    <div>
      <h1 class="text-text-primary text-2xl font-medium">{{ $t('play.server_manager.server_information') }}</h1>
      <div class="flex flex-row pt-8 space-x-32">
        <div class="flex flex-col">
          <ul class="space-y-4 text-text-secondary">
            <li>{{ $t('play.server_manager.ip_address') }}</li>
            <li>{{ $t('play.server_manager.current_map') }}</li>
            <li>{{ $t('play.server_manager.current_mod') }}</li>
          </ul>
        </div>

        <div class="flex flex-col">
          <ul class="space-y-4 text-text-primary text-right" v-if="activeServer?.status === 'online'">
            <li>
              {{ activeServer?.ip }}:{{ activeServer?.port }}
            </li>
            <li>
              {{ activeServer?.active_map || $t('play.server_manager.not_available') }}
            </li>
            <li>
              {{ activeServer?.active_mod || $t('play.server_manager.not_available') }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- player info -->
    <!-- <div>
      <h1 class="text-text-primary text-2xl font-medium">Current Players ― {{  }}</h1>
      <div class="flex flex-col py-8 flex-wrap max-h-56">
        <div
          v-for="player in activeServer?.connected_players"
          :key="player"
          class="w-12 flex flex-col items-center relative mb-4 mr-4"
        >
          <div
            class="w-12 h-12 bg-gray-900 rounded-full flex justify-center items-center"
          >
            <img
              src="../assets/logos/refrag-icon-button@2x.png"
              class="w-11 h-11 rounded-full"
            />
          </div>
          <div class="text-gray-300 text-xs">
            {{ player?.name }}
          </div>
        </div>
      </div>
    </div> -->
  </div>
  <ModalWindow :open="showKickModal" @toggleModal="toggleKickModel">
    <KickPlayerModal
      @toggleModal="toggleKickModel"
      @submitCommand="submitCommand"
      :kickPlayer="kickPlayer"
    />
  </ModalWindow>
</template>

<script setup>
import { ref } from 'vue';
import KickPlayerModal from '../KickPlayerModal.vue';
import ModalWindow from '../ModalWindow.vue';

const emits = defineEmits(['submitCommand']);

const props = defineProps({
  activeServer: {
    type: Object,
  },
  activeTeam: {
    type: Object,
  },
});

</script>
